module.exports = {
  mounted() {
    console.log('login mixin')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/login-mixin.js